// API URL Configuration
// Can be overridden with REACT_APP_API_URL environment variable
// Default: Production API
const rawUrl = process.env.REACT_APP_API_URL || "https://api.exihire.com/api";
const API_BASE_URL = rawUrl.endsWith('/api') || rawUrl.endsWith('/api/') ? rawUrl : `${rawUrl.replace(/\/$/, "")}/api`;

export default API_BASE_URL;